module.exports = __webpack_public_path__ + "img/globe.51392958.svg";